export const hostname = window.location.href.includes("localhost") ? "http://localhost/shivay-durga/" : "https://api.shivaydurga.com/";
export const MAP_API_KEY = "AIzaSyAvhjv8UL4uAJkAoh3CAF24ZEcg4huRbcg";